import { ProcessTypeEnum } from '../models/cartDetails/process-type.enum';
import { Injectable } from '@angular/core';
import { PromotionTypeEnum } from '../models/cartDetails/promotionType.model';
import { ServiceTypeEnum } from '../models/cartDetails/service-type.enum';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { IBundle, ICartDetails, ISimCardDiscount, ISummaryPrice, PcpiPrices } from '../interfaces/cart-details.interface';
import { MainProcessTypeEnum } from '../models/cartDetails/main-process-type.enum';
import { BrandTypeEnum } from '../models/cartDetails/brand-type.enum';

declare let window: any;

@Injectable()
export class CommonInfoService {
  public offerTitle = '';
  public isBohoOffer = false;
  public b2c = true;
  public taxName = 'net';
  public priceEnding = 'zł';
  public currentlyProcessed: number;
  public pageStep: number = window.STEP;
  public isFirstPage = window.STEP === 1;
  public isSecondPage = window.STEP === 2;
  public isThirdPage = window.STEP === 3;
  public isFourthPage = window.STEP === 4;
  public processType: ProcessTypeEnum = ProcessTypeEnum.ACQUISITION;
  public mainOfferProcessType: MainProcessTypeEnum = MainProcessTypeEnum.ACQUISITION;
  public discountInformation: string;
  public simCardDiscount: ISimCardDiscount = null;
  public simCardDiscountApplied: boolean = null;
  public isSolo: boolean;
  public isVirginBrand: boolean;
  public isPromotionTypeInstallment: boolean;
  public isServiceTypeMix: boolean;
  public isOtherSalesOffer: boolean;
  public isMigrationOffer: boolean;
  public isRetentionOffer: boolean;
  public isRetentionMultiOffer: boolean;
  public isRetentionSoloOffer: boolean;
  public isUpsellOffer: boolean;
  public isMnpOffer: boolean;
  public isNextSim: boolean;
  public portalUrl: string;
  public summaryPrices: ISummaryPrice[];
  public pcpiPrices: PcpiPrices;

  constructor(
    private notificationProvider: NotificationProviderService
  ) {
    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CART_DETAILS,
      (cartDetails: ICartDetails) => {
        if (cartDetails) {
          this.update(cartDetails);
        }
      });
  }

  private update(cartDetails: ICartDetails): void {
    this.offerTitle = cartDetails.headerData.title;
    this.processType = cartDetails.processType;
    this.mainOfferProcessType = cartDetails.mainOfferProcessType;
    this.isBohoOffer = cartDetails.processType === ProcessTypeEnum.CART_BOHO;
    this.b2c = cartDetails.b2c;
    this.taxName = this.b2c ? 'gross' : 'net';
    this.priceEnding = this.b2c ? 'zł' : `zł +\u00A0VAT`;
    this.currentlyProcessed = cartDetails?.commonProcessData?.group?.currentlyProcessed;
    this.discountInformation = cartDetails.discountInformation;
    this.simCardDiscount = cartDetails.simCardDiscount;
    this.simCardDiscountApplied = cartDetails.simCardDiscountApplied;
    this.isSolo = cartDetails.processType !== ProcessTypeEnum.CART_ACQUISITION_FAMILY
      && cartDetails.processType !== ProcessTypeEnum.CART_BOHO;
    this.isVirginBrand = window.HELPER_DATA.brand === BrandTypeEnum.VIRGIN;
    this.isPromotionTypeInstallment = this.getPromotionTypeInstallment(cartDetails);
    this.isServiceTypeMix = cartDetails.serviceType === ServiceTypeEnum.MIX;
    this.isOtherSalesOffer = cartDetails.mainOfferProcessType === MainProcessTypeEnum.OTHER_SALES;
    this.isMigrationOffer = cartDetails.mainOfferProcessType === MainProcessTypeEnum.PREPAID_2_POSTPAID;
    this.isRetentionOffer = cartDetails.mainOfferProcessType === MainProcessTypeEnum.RETENTION;
    this.isRetentionMultiOffer = this.isRetentionOffer && !this.isSolo; // business name = "GROOT"
    this.isRetentionSoloOffer = this.isRetentionOffer && this.isSolo; // solo tylko dla DATA
    this.isMnpOffer = cartDetails.mainOfferProcessType === MainProcessTypeEnum.MNP;
    this.isNextSim = cartDetails.nextSim;
    this.isUpsellOffer = cartDetails.mainOfferProcessType === MainProcessTypeEnum.UPSELL;
    this.portalUrl = window.PORTAL_URL;
    this.summaryPrices = cartDetails.summaryPrices;
    this.pcpiPrices = cartDetails.pcpiPrices;

    this.notificationProvider.publish(NotificationProviderTypeEnum.COMMON_INFO, this);
  }

  private getPromotionTypeInstallment(cartDetails: ICartDetails): boolean {
    return !!(cartDetails.bundles as IBundle[]).find((bundle: IBundle) => {
      return bundle.offer.promotionType === PromotionTypeEnum.INSTALLMENT;
    });
  }
}

